<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row d-flex justify-content-between">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa-solid fa-robot" aria-hidden="true" style="font-size:21px;margin-right:8px;color:var(--iq-primary);"></i>
              {{ cvCardTitle }}
            </h4>
          </div>
          <div class="d-flex align-items-center pl-2 pl-sm-0" style="gap:8px;">
            <b-button class="right-align-sm" variant="primary" @click="wrkSubAgentAdd()">{{ cvbtnAddNew }}</b-button>
            <ReviewsModal/>
          </div>

        </div>

        <!-- Filters -->
        <div class="iq-card row p-3">
          <b-col>
            <b-row class="col-12 col-xl-12">
              <b-col class="col-12 mb-3">
                <b-form-input
                  id="search"
                  v-model="whereFilter.search_param"
                  type="search"
                  :placeholder="cvSearchText"
                  @input="searchFromBackend"
                />
              </b-col>
            </b-row>
            <b-row class="col-12 mb-2">
              <b-col class="mb-2 col-12 col-sm-6">
                <select
                  v-if="agents.length > 0"
                  v-model="whereFilter.agent_id"
                  class="form-control"
                  title="Agent List"
                  @change="setAgentId"
                >
                  <option v-for="(agent, idx) in agents" :key="idx" :value="agent.agent_id">
                    {{ agent.agent_name || agent.agent_id }}
                  </option>
                </select>
              </b-col>
            </b-row>
          </b-col>
        </div>

        <!-- Table -->
        <div class="iq-card row p-3 d-flex align-items-center" :style="{ minHeight: (!wrkSubAgentObjList || wrkSubAgentObjList.length === 0) ? '400px' : 'auto'}">
          <b-col v-if="wrkSubAgentObjList && Array.isArray(wrkSubAgentObjList) && wrkSubAgentObjList.length > 0" md="12">
            <b-table
              hover
              responsive
              :items="wrkSubAgentObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
            >
              <template v-slot:cell(id)="data">
                <span style="display:block;width:50px">{{ wrkSubAgentObjList.indexOf(data.item) + 1 }}</span>
              </template>

              <template v-slot:cell(sa_order_id)="data">
                <span :title="data.item.sa_order_id">{{ data.item.sa_order_id }}</span>
              </template>

              <template v-slot:cell(sa_id)="data">
                <div style="white-space: normal; word-break: break-word; overflow-wrap: break-word;">
                  <span :title="data.item.sa_id">{{ data.item.sa_id ?? "-" }}<i v-if="data.item.sa_id" class="fa-solid fa-copy pointer font-size-18 ml-2" @click="doCopy(data.item.sa_id)"></i></span>
                </div>
                <b-button title="Edit Sub Agent" variant="mr-1 actionIcon" size="sm" @click="wrkSubAgentEdit('MODAL', data.item)">
                  <i class="ri-ball-pen-fill m-0 font-size-20"></i>
                </b-button>
                <b-button title="View Sub Agent" variant="actionIcon" size="sm" @click="wrkSubAgentView(data.item)">
                  <i class="fa fa-eye m-0 font-size-20"></i>
                </b-button>
              </template>

              <template v-slot:cell(agent_id)="data">
                <span :title="data.item.agent_id">{{ data.item.agent_id }}</span>
              </template>

              <template v-slot:cell(sa_desc)="data">
                <span :title="data.item.sa_desc">{{ data.item.sa_desc || '-' }}</span>
              </template>

              <template v-slot:cell(sa_type)="data">
                <b-badge :variant="badgeVariantForType(data.item.sa_type)" class="text-uppercase">
                  {{ data.item.sa_type || '-' }}
                </b-badge>
              </template>

              <template v-slot:cell(sa_svc)="data">
                <span :title="data.item.sa_svc">{{ data.item.sa_svc || '-' }}</span>
              </template>

              <template v-slot:cell(sa_action)="data">
                <span :title="data.item.sa_action">
                  {{ data.item.sa_action ? (data.item.sa_action.length > 100 ? data.item.sa_action.substring(0, 100) + '...' : data.item.sa_action) : '-' }}
                </span>
              </template>

              <template v-slot:cell(created_on)="data">
                {{ data.item.created_on | dateFormatDDMMYY }}
              </template>
            </b-table>

            <div class="d-flex align-items-center mt-3 py-3">
              <b-col v-if="(currentBatchNo * dataPerPage) < totalDataCount" sm="7" md="8" class="my-1">
                <b-btn variant="primary" @click="loadMoreData">Load More</b-btn>
              </b-col>
            </div>
          </b-col>
          <b-col v-else-if="wrkSubAgentObjList && Array.isArray(wrkSubAgentObjList) && wrkSubAgentObjList.length === 0">
            <h5 class="text-secondary text-center">No matching sub agents found.</h5>
          </b-col>
          <b-col v-else class="text-center py-5">
            <b-spinner variant="primary" class="align-middle"></b-spinner>
            <h5 class="mt-3 text-primary">Loading sub agents...</h5>
            <p class="text-muted mb-0">Please wait while sub agent records are being loaded.</p>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <!-- Add Modal -->
    <b-modal
      v-model="showModelWrkSubAgentAdd"
      scrollable
      :title="cvAddModalHeader"
      size="xxl"
    >
      <wrkSubAgentAdd
        :propOpenedInModal="true"
        :propAgents="agents"
        :propSelectedAgentId="whereFilter.agent_id"
        @emitCloseWrkSubAgentAddModal="closeWrkSubAgentAddModal"
      />
      <template #modal-footer="">
        <b-button size="sm" @click="closeWrkSubAgentAddModal">{{ cvbtnModalCancel }}</b-button>
      </template>
    </b-modal>

    <!-- Edit Modal -->
    <b-modal
      v-model="showModelWrkSubAgentEdit"
      scrollable
      :title="cvEditModalHeader"
      size="xxl"
    >
      <wrkSubAgentEdit
        :propOpenedInModal="true"
        :propWrkSubAgentObj="wrkSubAgentEditObj"
        :propAgents="agents"
        @emitCloseWrkSubAgentEditModal="closeWrkSubAgentEditModal"
      />
      <template #modal-footer="">
        <b-button size="sm" @click="closeWrkSubAgentEditModal">{{ cvbtnModalCancel }}</b-button>
      </template>
    </b-modal>

    <!-- View Modal -->
    <b-modal
      v-model="showModelWrkSubAgentView"
      scrollable
      :title="cvViewModalHeader"
      size="xxl"
    >
      <wrkSubAgentView :propWrkSubAgentObj="wrkSubAgentViewObj" />
      <template #modal-footer="">
        <b-button size="sm" @click="closeWrkSubAgentViewModal">{{ cvbtnModalCancel }}</b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">

      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { socialvue } from "../../../config/pluginInit.js"
import { WrkAgentApiObj } from "../../../FackApi/api/wrkAgent.js"
import { wrkSubAgents } from "../../../FackApi/api/wrkSubAgent.js"
import Utility from "../../../Utils/utility.js"

import wrkSubAgentAdd from "./WrkSubAgentAdd.vue"
import wrkSubAgentEdit from "./WrkSubAgentEdit.vue"
import wrkSubAgentView from "./WrkSubAgentView.vue"
import ReviewsModal from "./ReviewsModal.vue"

export default {
  name: "wrkSubAgentList",
  components: {
    wrkSubAgentAdd,
    wrkSubAgentEdit,
    wrkSubAgentView,
    ReviewsModal
  },
  data () {
    return {
      cvCardTitle: "Workflow Sub Agents",
      cvbtnAddNew: "Add",
      cvSearchText: "Type to Search",
      cvEditModalHeader: "Edit Sub Agent",
      cvAddModalHeader: "Add Sub Agent",
      cvViewModalHeader: "View Sub Agent",
      cvbtnModalCancel: "Cancel",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Sub Agent",
      showModelWrkSubAgentAdd: false,
      showModelWrkSubAgentEdit: false,
      showModelWrkSubAgentView: false,
      sortBy: "",
      sortDesc: false,
      columns: [
        { label: "#", key: "id", class: "text-left align-text-top", sortable: false },
        { label: "Order", key: "sa_order_id", class: "text-left align-text-top w-120px" },
        { label: "Sub Agent Id", key: "sa_id", class: "text-left align-text-top w-350px" },
        { label: "Agent Id", key: "agent_id", class: "text-left align-text-top w-300px" },
        { label: "Description", key: "sa_desc", class: "text-left align-text-top w-300px" },
        { label: "Type", key: "sa_type", class: "text-left align-text-top w-150px" },
        { label: "Service", key: "sa_svc", class: "text-left align-text-top w-200px" },
        { label: "Payload", key: "sa_payload", class: "text-left align-text-top w-200px" },
        { label: "Action", key: "sa_action", class: "text-left align-text-top w-350px" },
        { label: "Output", key: "sa_output", class: "text-left align-text-top w-200px" },
        { label: "Created On", key: "created_on", class: "text-left align-text-top w-200px" }
      ],
      wrkSubAgentObjList: null,
      wrkSubAgentEditObj: null,
      wrkSubAgentViewObj: null,
      currentBatchNo: 1,
      dataPerPage: 25,
      totalDataCount: 0,
      agents: [],
      whereFilter: {
        search_param: "",
        agent_id: null
      },
      doCopy: Utility.doCopy
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async mounted () {
    socialvue.index()

    const agentId = this.$route.params.agent_id
    if (agentId) {
      this.whereFilter.agent_id = agentId
    }

    await this.wrkAgentList()

    // keep dropdown selection in sync with route param
    if (!this.whereFilter.agent_id && this.agents.length) {
      this.whereFilter.agent_id = this.agents[0].agent_id
      this.$router.replace({ params: { agent_id: this.whereFilter.agent_id } }).catch(() => {})
    }

    await this.wrkSubAgentList()
  },
  methods: {
    /**
     * badgeVariantForType
     */
    badgeVariantForType (t) {
      return "primary"
    },
    /**
     * wrkAgentList
     */
    async wrkAgentList () {
      try {
        const resp = await WrkAgentApiObj.wrkAgentList(this, { currentBatchNo: 1, dataPerPage: 500, module_name: null, search_param: "" })
        if (resp && resp.resp_status) {
          this.agents = resp.resp_data.data || []
        }
      }
      catch (e) {
        console.error("Failed to load agents for dropdown", e)
        this.agents = []
      }
    },
    /**
     * searchFromBackend
     */
    searchFromBackend () {
      if (this.whereFilter.search_param.length <= 2 && this.whereFilter.search_param.length !== 0) {
        return
      }
      this.currentBatchNo = 1
      this.wrkSubAgentList()
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      await this.wrkSubAgentList(true)
    },
    /**
     * wrkSubAgentList
     */
    async wrkSubAgentList (loadViaLoadMore = false) {
      try {
        if (!this.whereFilter.agent_id) {
          this.wrkSubAgentObjList = []
          this.totalDataCount = 0
          return
        }

        const where = {
          currentBatchNo: this.currentBatchNo,
          dataPerPage: this.dataPerPage,
          search_param: this.whereFilter.search_param,
          agent_id: this.whereFilter.agent_id
        }

        const resp = await wrkSubAgents.wrkSubAgentList(this, where)

        if (resp && resp.resp_status) {
          if (!loadViaLoadMore) {
            this.wrkSubAgentObjList = [...resp.resp_data.data]
          }
          else {
            this.wrkSubAgentObjList = [...this.wrkSubAgentObjList, ...resp.resp_data.data]
          }
          this.totalDataCount = resp.resp_data_total_count
        }
        else {
          this.toastMsg = resp?.resp_msg || "Failed to fetch sub agents"
          this.toastVariant = "danger"
          this.showToast = true
          this.wrkSubAgentObjList = []
          this.totalDataCount = 0
        }
      }
      catch (e) {
        console.error("Exception at wrkSubAgentList()", e)
        this.toastMsg = "Failed to fetch sub agents. Please try again."
        this.toastVariant = "danger"
        this.showToast = true
        this.wrkSubAgentObjList = []
        this.totalDataCount = 0
      }
    },
    /**
     * wrkSubAgentAdd
     */
    wrkSubAgentAdd () {
      this.showModelWrkSubAgentAdd = true
    },
    /**
     * wrkSubAgentEdit
     */
    wrkSubAgentEdit (type, item) {
      if (type === "FULLPAGE") {
        this.$router.push("/wrk_sub_agent_edit/" + item.sa_id)
      }
      else {
        this.wrkSubAgentEditObj = item
        this.showModelWrkSubAgentEdit = true
      }
    },
    /**
     * wrkSubAgentView
     */
    wrkSubAgentView (item) {
      this.wrkSubAgentViewObj = item
      this.showModelWrkSubAgentView = true
    },
    /**
     * closeWrkSubAgentAddModal
     */
    closeWrkSubAgentAddModal () {
      this.showModelWrkSubAgentAdd = false
      this.wrkSubAgentList()
    },
    /**
     * closeWrkSubAgentEditModal
     */
    closeWrkSubAgentEditModal () {
      this.showModelWrkSubAgentEdit = false
      this.wrkSubAgentList()
    },
    /**
     * closeWrkSubAgentViewModal
     */
    closeWrkSubAgentViewModal () {
      this.showModelWrkSubAgentView = false
    },
    /**
     * setAgentId
     */
    setAgentId () {
      this.currentBatchNo = 1
      const agentId = this.whereFilter.agent_id
      if (agentId) {
        this.$router.replace({ params: { agent_id: agentId } }).catch(() => {})
      }
      this.wrkSubAgentList()
    }
  }
}
</script>
